import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { DuplicateVideoMenu, ItemId, VideoMasterRequest, VideoMenu } from '../types/items';
import { transformList } from './transformer';

class VideoMenuService {
  private route = apis.videoMenu;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<VideoMenu>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<VideoMenu>(`${this.route.list}/${id}`);

  template = () => this.api.get<VideoMenu>(`${this.route.list}/new`);

  save = (id: ItemId, {
    ref,
    permissions,
    ...videoMenu
  }: VideoMenu) => this.api.put(`${this.route.list}/${id}`, videoMenu);

  create = ({
    id, ref, permissions, ...videoMenu
  }: VideoMenu) => this.api.post<VideoMenu>(this.route.list, videoMenu);

  delete = (id: ItemId) => this.api.delete(`${this.route.list}/${id}`);

  duplicate = (duplicateVideoMenu: DuplicateVideoMenu) => this.api
    .post<DuplicateVideoMenu>(`${this.route.list}/${duplicateVideoMenu.video_menu_id}/clone`, duplicateVideoMenu);

  getVideoMaster = (id: number) => this.api.get<VideoMasterRequest>(`${this.route.record}/${id}/master`);

  generateVideoMaster = (id: number) => this.api.put(`${this.route.record}/${id}/master`, {});
}

export default new VideoMenuService(apiService);
